/* eslint-disable no-undef */
export default class AnalyticsHelper {
    static template(el, data) {
        const t = el.dataset.analyticsTemplate;
        if (t) { el.dataset.analytics = this.replace(t, data); }
    }

    static push(obj, location) {
        const data = obj instanceof HTMLElement ? this.el(obj) : obj;
        if(HONDA.analytics && data){ HONDA.analytics.push(data); }
        if(location) { setTimeout(() => window.location = location, 100); }
    }

    static el(el) {
        return el.dataset.analytics ? JSON.parse(el.dataset.analytics.replace(/\'/g, '\"')) : null;
    }

    static replace(template, data) {
        return template.replace(/\${([^}]+)}/g, (ignore, key) => ((key = this.get(key, data)) == null ? '' : key));
    }

    static get(path, data) {
        return path.split('.').reduce((p, c) => p && p[c] || '', data).replace(/"/g, '');
    }
}
